import { footerLinks } from "@/mocks/blog";

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const anchors = ["hot", "articles", "columns", "rambling", "about", "faq"];

  return (
    <footer className="bg-background-200">
      <div className="mx-auto w-full max-w-7xl px-4 pb-8 pt-14 md:px-6">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-focus-3-line text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-display text-xl font-bold text-foreground-950">
                吾爱<span className="text-primary-600">吃瓜</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              一个普通网友的个人观点博客。用我的看法、主观评价、吃瓜心得与碎碎念，陪你把每一个热点看透、想明白。
            </p>
            <div className="mt-5 flex gap-2.5">
              {["ri-wechat-fill", "ri-weibo-fill", "ri-bilibili-fill", "ri-mail-fill"].map((icon) => (
                <a
                  key={icon}
                  href="mailto:about@wuaichigua.example"
                  aria-label="社交关注"
                  rel="nofollow noopener"
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${icon} text-base`} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display text-base font-bold text-foreground-900">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {footerLinks["快速导航"].map((label, i) => (
                <li key={label}>
                  <button
                    onClick={() => scrollTo(anchors[i] || anchors[0])}
                    className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-display text-base font-bold text-foreground-900">热门栏目</h4>
            <ul className="mt-4 space-y-2.5">
              {footerLinks["热门栏目"].map((label) => (
                <li key={label}>
                  <button
                    onClick={() => scrollTo("columns")}
                    className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-display text-base font-bold text-foreground-900">联系我</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-primary-500" aria-hidden="true"></i>
                <a href="mailto:about@wuaichigua.example" className="break-all hover:text-primary-600" rel="nofollow">
                  about@wuaichigua.example
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-primary-500" aria-hidden="true"></i>
                <span>每周二、五晚更新</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-chat-3-line mt-0.5 text-primary-500" aria-hidden="true"></i>
                <span>欢迎来信交流观点</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-300 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 吾爱吃瓜 · 以个人视角记录我的看法，愿你保持独立思考。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="cursor-pointer hover:text-primary-600">
              回到顶部 <i className="ri-arrow-up-line" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}